import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=be062bf8&scoped=true"
import script from "./Heart.vue?vue&type=script&lang=js"
export * from "./Heart.vue?vue&type=script&lang=js"
import style0 from "./Heart.vue?vue&type=style&index=0&id=be062bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be062bf8",
  null
  
)

export default component.exports